import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Agreement } from "app/_models";
import { UsedCarAgreement } from "app/_models/used-cars/usedcaragreement";
import { Customer } from "app/_models/customer";
import { Dealer } from "app/_models/dealer";
import { EnvironmentService } from "app/_services";
import { AgreementsService } from "app/_services/agreements.service";
import { CustomersService } from "app/_services/customers.service";
import { DealersService } from "app/_services/dealers.service";
import { DomSanitizer } from "@angular/platform-browser";
import { NgForm } from "@angular/forms";
import { ProlongingsAgreement } from "app/_models/prolongings/prolongingsagreement";
import { UsedCarAgreementService } from "app/_services/matrix/products/used-cars-agreement.service";
import { ProlongingsAgreementService } from "app/_services/matrix/products/prolongings-agreement.service";

@Component({
  selector: "app-agreementacceptance",
  templateUrl: "./agreementacceptance.component.html",
  providers: [
    CustomersService,
    AgreementsService,
    UsedCarAgreementService,
    ProlongingsAgreementService,
    DealersService,
    EnvironmentService,
  ],
})
export class AgreementAcceptanceComponent implements OnInit {
  private agreement: Agreement;
  private usedCarAgreement: UsedCarAgreement;
  private prolongingsAgreement: ProlongingsAgreement;
  private agreementPdfUrl: string;
  private customer: Customer;
  private dealer: Dealer;

  private queryParameters = {
    dealerId: null,
    mauticId: null,
    regnr: null,
    agreementId: null,
    type: null,
  };

  private loading: boolean = false;

  private customerInfoResolved: boolean = false;
  private agreementInfoResolved: boolean = false;
  private agreementNotFound: boolean = false;
  private showErrorMessage: boolean = false;
  private showSuccessMessage: boolean = false;

  private authenticateUrl = this.environmentService.getBaseURL() + "/";

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private customerService: CustomersService,
    private agreementService: AgreementsService,
    private usedCarAgreementService: UsedCarAgreementService,
    private prolongingsAgreementService: ProlongingsAgreementService,
    private dealerService: DealersService,
    private environmentService: EnvironmentService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    // Get the customer data from the query params
    this.activatedRoute.queryParams.subscribe((params) => {
      this.queryParameters.dealerId = params["dealerId"];
      this.queryParameters.mauticId = params["mauticId"];
      this.queryParameters.regnr = params["regnr"];
      this.queryParameters.agreementId = params["agreementId"];
      this.queryParameters.type = params["type"];
      // Now, validate that all query parameters is present
      this.validateQueryParams();
    });
  }

  getSafeUrl() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.agreementPdfUrl);
  }

  validateQueryParams(): void {
    if (
      !this.queryParameters.dealerId ||
      !this.queryParameters.mauticId ||
      !this.queryParameters.regnr ||
      !this.queryParameters.agreementId
    ) {
      this.redirect();
    } else {
      this.getDealerInfo();
    }
  }

  getDealerInfo(): void {
    this.dealerService.read(this.queryParameters.dealerId).subscribe(
      (dealer) => {
        this.dealer = dealer;
        this.getCustomerInfo();
      },
      (error) => {
        this.agreementNotFound = true;
        this.redirect();
      }
    );
  }

  getCustomerInfo(): void {
    this.customerService
      .getCustomerByMauticIdAndRegistration(
        this.queryParameters.mauticId,
        this.queryParameters.regnr,
        this.queryParameters.dealerId
      )
      .subscribe(
        (customer) => {
          this.customerInfoResolved = true;
          this.customer = customer;

          if (this.queryParameters.type === "usedcars") {
            this.usedCarAgreementInfo();
          } else if (this.queryParameters.type === "prolongings") {
            this.prolongingsAgreementInfo();
          } else {
            this.getAgreementInfo();
          }
        },
        (error) => {
          console.log("cust not found");
          this.agreementNotFound = true;
          this.redirect();
        }
      );
  }

  getAgreementInfo(): void {
    this.agreementService.get(this.queryParameters.agreementId).subscribe(
      (agreement) => {
        this.agreementInfoResolved = true;
        this.agreement = agreement;
        this.agreementPdfUrl =
          this.authenticateUrl +
          (this.authenticateUrl.includes("localhost") ? "" : "api/") +
          "agreement/agreement_" +
          agreement._id +
          ".pdf";
      },
      (error) => {
        this.agreementNotFound = true;
        this.redirect();
      }
    );
  }

  usedCarAgreementInfo(): void {
    this.usedCarAgreementService
      .get(this.queryParameters.agreementId)
      .subscribe(
        (agreement) => {
          this.agreementInfoResolved = true;
          this.usedCarAgreement = agreement;
          // this.agreementPdfUrl =
          //   this.authenticateUrl +
          //   (this.authenticateUrl.includes("localhost") ? "" : "api/") +
          //   "agreement/usedCar/agreement_" +
          //   this.usedCarAgreement._id +
          //   ".pdf";
          this.agreementPdfUrl = this.authenticateUrl + "api/agreement/usedCar/agreement_" + 
          this.usedCarAgreement._id + ".pdf";
        },
        (error) => {
          this.agreementNotFound = true;
          this.redirect();
        }
      );
  }
  prolongingsAgreementInfo(): void {
    this.prolongingsAgreementService
      .get(this.queryParameters.agreementId)
      .subscribe(
        (agreement) => {
          this.agreementInfoResolved = true;
          this.prolongingsAgreement = agreement;
          // this.agreementPdfUrl =
          //   this.authenticateUrl +
          //   (this.authenticateUrl.includes("localhost") ? "" : "api/") +
          //   "agreement/prolongings/agreement_" +
          //   this.prolongingsAgreement._id +
          //   ".pdf";
          this.agreementPdfUrl = this.authenticateUrl + "api/agreement/prolongings/agreement_" + 
          this.prolongingsAgreement._id + ".pdf";
        },
        (error) => {
          this.agreementNotFound = true;
          this.redirect();
        }
      );
  }

  completeAgreement(): void {
    // Update show message booleans
    this.showErrorMessage = false;
    this.showSuccessMessage = false;
    this.loading = true;

    if (this.queryParameters.type === "usedcars") {
      this.usedCarAgreementService
        .acceptAgreement(
          this.usedCarAgreement,
          this.dealer,
          this.queryParameters.regnr,
          this.queryParameters.mauticId
        )
        .subscribe(
          (response) => {
            this.loading = false;
            this.showSuccessMessage = true;
          },
          (error) => {
            this.loading = false;
            this.showErrorMessage = false;
          }
        );
    } else if (this.queryParameters.type === "prolongings") {
      this.prolongingsAgreementService
        .acceptAgreement(
          this.prolongingsAgreement,
          this.dealer,
          this.queryParameters.regnr,
          this.queryParameters.mauticId
        )
        .subscribe(
          (response) => {
            this.loading = false;
            this.showSuccessMessage = true;
          },
          (error) => {
            this.loading = false;
            this.showErrorMessage = false;
          }
        );
    } else {
      this.agreementService
        .acceptAgreement(
          this.agreement,
          this.dealer,
          this.queryParameters.regnr,
          this.queryParameters.mauticId
        )
        .subscribe(
          (response) => {
            this.loading = false;
            this.showSuccessMessage = true;
          },
          (error) => {
            this.loading = false;
            this.showErrorMessage = false;
          }
        );
    }
  }

  redirect(): void {
    //window.location.href = this.getErrorRedirectUrl();
  }

  getErrorRedirectUrl(): string {
    if (this.dealer) {
      switch (this.dealer._id) {
        case "5ec7b995f99d985b5e8f02ab":
          return "https://nellemann.dk/";

        case "5a217c8c865e0807cb47fa9c":
          return "https://www.bilhusetelmer.dk/";

        default:
          return "https://forhandlerportal.micar.dk/";
      }
    } else {
      return "https://forhandlerportal.micar.dk/";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/landingpages/agreementacceptance/agreementacceptance.component.ts